// LikesPage.tsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import UserInteractionFeed from '../UserInteractionFeed/index';

const LikesPage: React.FC = () => {
  const { user } = useAuth();
  const username = user?.username ?? 'You';

  return (
    <UserInteractionFeed
      kind="LIKED"
      title={`${username} likes`}
      emptyMessage="You haven’t liked any posts yet."
    />
  );
};

export default LikesPage;
